import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';

import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';
import { querySelector } from '../../../utils';

export const GET_ALL_USERS_QUERY = gql`
  query GetAllUsers($districtId: Int, $departmentId: Int, $excludeTerminatedUsers: Boolean) {
    all_users(
      exclude_salary: true, 
      exclude_terminated: $excludeTerminatedUsers, 
      exclude_terminated_before: 6, 
      district_id: $districtId, 
      department_id: $departmentId 
    ) {
     edges {
       node {
         fullname
         id
       }
     }
   }
  }
`;

const queryAllUsers = graphql(GET_ALL_USERS_QUERY);

const mapAllUsersToProps = withProps((props) => {
  const { data } = props;
  const allUsers = querySelector(data, '$.all_users.edges[*].node', []);

  return {
    allUsers,
  };
});

export const queryAllUsersGQL = compose(
  queryAllUsers,
  queryMetaHandler,
  mapAllUsersToProps,
  omitProps(['data']),
);

const GET_PAST_TIMESHEETS_QUERY = gql`
  query GetPastTimesheets($userId: Int!, $originDate: String!, $periods: Int!) {
    all_timesheets_for_one_user(end_date: $originDate, weeks_back: $periods, user_id: $userId) {
      edges {
        node {
          id
          start_date {
            iso8601
            display
          }
          total_hours {
            to_string
          }
        }
      }
    }
  }
`;

const queryPastTimesheets = graphql(GET_PAST_TIMESHEETS_QUERY);

const mapPastTimesheetsToProps = withProps((props) => {
  const { data } = props;
  const weeklyTimesheetSummaries = querySelector(data, '$.all_timesheets_for_one_user.edges[*].node', []);

  return {
    weeklyTimesheetSummaries,
  };
});

export const queryPastTimesheetsGQL = compose(
  queryPastTimesheets,
  queryMetaHandler,
  mapPastTimesheetsToProps,
  omitProps(['data']),
);
